export default __webpack_public_path__ + "static/media/sample.2b46cd61.jpg";